import React from 'react';
import { render } from 'react-dom';

import App from './App';
import { setupFirebase } from './services/firebase';

setupFirebase();
render(<App />, document.getElementById('root'));
